import React from 'react';
import { OPEN_ROLES } from '../../data/openRoles';

export function TeamSection() {
  return (
    <section className="section fade-in">
      <div className="section-label">The Team</div>
      <h2>The seats we&rsquo;re filling</h2>
      <p className="team-intro">
        TrueNooch™ is currently founder-led out of Colorado. The mission is bigger than one person — and these are the seats we’re filling. If any of them sound like you, reach out.
      </p>
      <div className="team-roles">
        {OPEN_ROLES.map((r) => (
          <div key={r.title} className="role-card">
            <div className="role-card-tag">Open Seat</div>
            <div className="role-card-title">{r.title}</div>
            <div className="role-card-desc">{r.desc}</div>
          </div>
        ))}
      </div>
      <p className="team-cta">
        Want in? Email{' '}
        <a href="mailto:jarvis@truenooch.com?subject=Joining%20TrueNooch">jarvis@truenooch.com</a>.
      </p>
    </section>
  );
}
